<!-- 勾选栏 -->
<template>
  <div class="check-row">
    <check-box-item
      :is-checked="isChecked"
      @clickItem="changeSelect"
    />

    <p v-if="text" class="check-text">{{ text }}</p>
    <img
      v-if="showTip"
      @click="$emit('showTip')"
      class="image"
      src="https://j5.dfcfw.com/sc/image/202110/20211009012345.png"
    />
  </div>
</template>

<script>
import CheckBoxItem from './CheckBoxItem.vue';

export default {
  components: {
    CheckBoxItem,
  },
  props: {
    isChecked: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    showTip: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changeSelect(params) {
      this.$emit('changeSelect', params);
    },
  },
};
</script>

<style scoped>
.check-text {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #666666;
  line-height: 24px;
  font-weight: 400;
  text-overflow: ellipsis;
  max-width: 568px;
}

.check-row {
  display: flex;
  margin: 8px 0 0 24px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.image {
  /* px2wx:change next */
  width: 28px;
  height: 28px;
  margin-left: 16px;
}
</style>
